import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const SmallDetailCard = (props) => {
  const sc = props.slice.primary;

  const data = props.slice.items;

  let bg;
  if (sc.background === "gradient") {
    bg = "gradient-to-b from-grey-light to-white";
  } else if (sc.background === "grey") {
    bg = "grey-light";
  } else {
    bg = sc.background;
  }


  return (
    <section className={"relative my-6 bg-" + bg}>
      <div className="wrapper flex flex-col md:flex-row gap-6">
        {data.map((card, index) => {
          return(
            <Link key={index} to={card.link.url} className="sm-detail-card">
              <div className="flex flex-col justify-between">
              <div className="relative">
                <GatsbyImage image={getImage(card.card_hero_image)} alt={card.card_hero_image.alt || card.card_title.text} />
                {card.card_logo.url ? <img className="w-48 md:w-1/3 mb-8 absolute bottom-0 left-8" src={card.card_logo.url} alt={card.card_logo.alt || card.card_title.text} /> : ''}
              </div>
              
              <div className="p-8 pb-0">
                <div className="text-xl font-bold">{card.card_title.text}</div>
                <div className="relative mb-6">
                  <div className="mt-4">
                      <span className={"dta block text-" + (card.theme)}>{card.data_point.text}</span>
                      <span>{card.data_description}</span>
                  </div>
                </div>
                
              </div>
              </div>
              
            </Link>
          )
        })}
        
      </div>
    </section>
  );
};
